module.exports = __webpack_public_path__ + "assets/src/style/img/footer-gemeente.png?8c587f3e9fda0f5eaed780fd81629d95";